// Resolución de idioma. Vive fuera de LanguageContext a propósito: el layout
// (server component) necesita resolverlo ANTES de renderizar, y no puede
// importar un módulo 'use client'.
//
// Por qué existe esto: el idioma se resolvía solo en el cliente (useState('en')
// + efecto), así que el HTML del servidor salía SIEMPRE en inglés y el idioma
// real recién aparecía tras hidratar — un parpadeo para todo el que no hable
// inglés, y contenido en inglés para cualquier crawler que no ejecute JS.

export const SUPPORTED_LANGUAGES = ['en', 'es', 'pt']
export const DEFAULT_LANGUAGE = 'en'
export const LANGUAGE_COOKIE = 'app-lang'
// Mismo nombre que la clave de localStorage que ya usaba la app, para que un
// usuario viejo no pierda su elección: el cliente migra localStorage → cookie.

export function isSupported(lang) {
    return SUPPORTED_LANGUAGES.includes(lang)
}

/**
 * Parsea un header Accept-Language ("pt-BR,pt;q=0.9,en;q=0.8") y devuelve el
 * primer idioma soportado por peso. Sólo mira el código base ("pt-BR" → "pt"):
 * la app no distingue variantes regionales.
 */
export function fromAcceptLanguage(header) {
    if (!header) return null
    const ranked = header
        .split(',')
        .map((part) => {
            const [tag, ...params] = part.trim().split(';')
            const q = params.find((p) => p.trim().startsWith('q='))
            return { base: tag.trim().toLowerCase().split('-')[0], q: q ? parseFloat(q.split('=')[1]) : 1 }
        })
        .filter((x) => x.base && !Number.isNaN(x.q))
        .sort((a, b) => b.q - a.q)

    return ranked.find((x) => isSupported(x.base))?.base ?? null
}

/** Cookie explícita > Accept-Language del browser > inglés. */
export function resolveLanguage({ cookie, acceptLanguage } = {}) {
    if (isSupported(cookie)) return cookie
    return fromAcceptLanguage(acceptLanguage) ?? DEFAULT_LANGUAGE
}
